import { render, staticRenderFns } from "./AddCompanyAction.vue?vue&type=template&id=0858af47&"
import script from "./AddCompanyAction.vue?vue&type=script&lang=js&"
export * from "./AddCompanyAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports